import { render, staticRenderFns } from "./ziliao.vue?vue&type=template&id=fe9ded3a&scoped=true"
import script from "./ziliao.vue?vue&type=script&lang=js"
export * from "./ziliao.vue?vue&type=script&lang=js"
import style0 from "./ziliao.vue?vue&type=style&index=0&id=fe9ded3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe9ded3a",
  null
  
)

export default component.exports